export default "__VITE_ASSET__DKlWvxsv__"